<template>
	<div class="js-sidebar-scroll">
		<div class="content-side content-side-user px-0 py-0">
			<div class="smini-hidden text-center mx-auto">
				<a class="img-link" href="javascript:void(0)"
					:set=" img_bg=$page.props.rank_prefix=='S' ? '0891b2' 
							: ($page.props.rank_prefix=='G' ? 'FEC10D'
							: ($page.props.rank_prefix=='GC' ? 'dfa705'
							: ($page.props.rank_prefix=='D' ? 'd97706'
							: ($page.props.rank_prefix=='P'	? '22844b'
							: ($page.props.rank_prefix=='PC'? '36b3a0'
							: ($page.props.rank_prefix=='PF'? '32a67f'
							: ($page.props.rank_prefix=='B' ? '8f55f2'
							: '343a40'
							)))))))
						"
				>
					<img
						v-if="userRole === 'Admin'"
						class="img-avatar img-avatar48 me-3 user-avatar"
						:src="
							'https://ui-avatars.com/api/?size=128&background='+img_bg+'&color=fff&font-size=0.5&bold=true&length=1&name=' +
							user.full_name
						"
					/>
					<img
						v-else
						class="img-avatar img-avatar48 me-3 user-avatar"
						:src="
							user.avatar === 'default-avatar.png'
								? 'https://ui-avatars.com/api/?size=128&background='+img_bg+'&color=fff&font-size=0.5&bold=true&length=1&name=' +
								  user.full_name
								: '/avatar/' + user.avatar
						"
						alt="avatar"
					/>
				</a>
				<ul class="list-inline mt-3 mb-0">
					<li class="list-inline-item">
						<inertia-link
							class="link-fx text-dual fs-sm fw-semibold text-uppercase"
							:href="route('member.profile')"
						>
							{{ user.full_name }} <i v-if="userRole!='Admin' && (user.edit!==1 || user.mobile===null || user.mobile==='' || user.c_fblink===null)" class="fa fa-exclamation-circle text-danger"></i>
						</inertia-link>
					</li>
					<li class="list-inline-item">
						<inertia-link
							:href="'/post/log-out?role='+userRole.toLowerCase()"
							method="post"
							as="button"
							class="link-fx text-dual btn btn-sm"
						>
							<i class="fa fa-sign-out-alt"></i>
						</inertia-link>
					</li>
				</ul>
			</div>
		</div>
		<div class="content-side content-side-full">
			<ul v-if="userRole === 'Member'" class="nav-main">
				<member :user="user" :sidebar-menus="sidebarMenus" />

				<div v-if="surveys.length>0" class="text-center mt-5">
					<button type="button" @click="$emit('toggle-survey')" class="btn btn-outline-info btn-sm">We'd love to hear from you</button>
				</div>

			</ul>
			<ul v-else-if="userRole === 'Admin'" class="nav-main">
				<admin :user="user" />
			</ul>
			<ul v-else-if="userRole === 'Community'" class="nav-main">
				<community :user="user" :sidebar-menus="sidebarMenus" :communities-visited="communitiesVisited" :my-communities="myCommunities" />
			</ul>
			<ul v-else-if="userRole === 'BCC'" class="nav-main">
				<blockchain-circle :user="user" :sidebar-menus="sidebarMenus" />
			</ul>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import { Admin, Member, BlockchainCircle, Community } from './Contents'

export default {
	name: 'Sidebar',
	props: {
		user: Object,
		userRole: String,
		sidebarMenus: Object,
		myCommunities: Object,
		communitiesVisited: Object,
		surveys 	: Object
	},
	components: {
		Admin,
		Member,
		BlockchainCircle,
		Community,
	},
	setup() {
		onMounted(() => {
			const page = document.getElementById('page-container')
			setTimeout(() => {
				if (page.classList.contains('side-trans-enabled') == false) {
					window.location.reload()
				}
			}, 10)
		})

	},
}
</script>
